/** Виды работ, скрытые в табеле (учёт на бэкенде, в UI не показываем). */
const TIMESHEET_HIDDEN_JOB_TYPE_NAMES = new Set(["Компенсация"]);

/** ID видов работ — дополнение к имени (Компенсация). */
export const TIMESHEET_HIDDEN_JOB_TYPE_IDS = [1855];

export const isHiddenFromTimesheet = (report) => {
  const jobType = report?.portal_job_type;
  if (!jobType) return false;
  if (TIMESHEET_HIDDEN_JOB_TYPE_NAMES.has(jobType.name)) return true;
  return TIMESHEET_HIDDEN_JOB_TYPE_IDS.includes(jobType.id);
};

export const filterTimesheetVisibleReports = (reports) =>
  (reports || []).filter((report) => !isHiddenFromTimesheet(report));

export const isCompensationReport = isHiddenFromTimesheet;
